import { css } from "glamor";
import * as theme from "../theme";

export default function ButtonInput ({
  label,
  error,
  className,
  checked,
  disabled,
  ...props
}) {
  return (
    <label className={className}>
      <input
        type="radio"
        className={css({
          position: 'absolute',
          left: -10000000,
        })}
        {...props}
        disabled={disabled}
        checked={checked}
      />
      <span
        className={css(
          {
            backgroundColor: theme.gray05,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 80,
            padding: '8px 6px',
            transition: 'all 100ms linear',
            textTransform: 'capitalize'
          },
          !disabled && !checked && {
            ':hover': {
              outline: 'none',
              borderColor: theme.blue,
              opacity: '0.8',
            },
            ':active': {
              opacity: '0.6',
            },
          },
          checked && {
            backgroundColor: theme.green,
            color: 'white',
          },
          disabled && {
            opacity: 0.5,
          },
          disabled &&
            checked && {
              backgroundColor: theme.gray60,
            },
        )}
      >
        {label.toLowerCase()}
      </span>
    </label>
  );
}
